/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useContext, useEffect, useLayoutEffect } from 'react';
import { Page } from 'Components';
import { AppContext, AuthContext } from 'Context';
import { axios, endpoints, baseUrl } from 'Api';
import { logAppEvent } from 'Api/errorLogger';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setDidCardAdded } from 'store/store';
import Dialog from '@mui/material/Dialog';
import styles from './index.module.css';
import { InfoModal } from '../../dashboard/info-modal';
import CardDetails from './CardDetails';
import AddCard from './AddCard/AddCard';

export function ManagePaymentMethods() {
  const { subscriptionDetails, langText, setAppSnackbar, setcardAdded, getSubscription, cardPayId, setcardUpdateBoolean, setcardPayId } = useContext(AppContext);
  const { isInActiveUser, gettingSubscription, getToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(false);

  const paymentMethodText = langText?.settings?.billPayment?.paymentMethod;
  const lastPlanId = subscriptionDetails?.plans?.[subscriptionDetails?.plans?.length - 1]?.plan_id;
  const [renewingPlan, setRenewingPlan] = useState(false);

  const dispatch = useDispatch();
  const handleUpdateState = () => {
    dispatch(setDidCardAdded(false));
  };
  useLayoutEffect(() => {
    if (searchParams.get('add') === 'true') {
      setOpen(true);
    }
  }, [searchParams]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const didCardAdded = useSelector((state) => state.didCardAdded);

  useEffect(() => {
    if (subscriptionDetails?.paymentMethods) {
      setPaymentMethods(subscriptionDetails?.paymentMethods);
    }
  }, [subscriptionDetails]);
  const handleClose = () => {
    setOpen(false);
  };

  const renewPlan = async () => {
    setRenewingPlan(true);
    try {
      const myToken = await getToken();
      const apiUrl = `${baseUrl}/${endpoints.addPlanV2}`;
      const requestBody = {
        token: myToken,
        plan_id: lastPlanId,
        is_free: 0,
        upgrade: false,
        trial: false
      };
      const response = await axios.post(apiUrl, requestBody);
      setAppSnackbar({
        isVisible: true,
        type: 'success',
        message: response?.data?.message || 'Plan renewed successfully',
      });
      handleUpdateState();
      getSubscription();
      navigate('/settings/billings-and-payments');
      window.location.reload();
    } catch (error) {
      const responseData = error?.response?.data?.message;
      logAppEvent({
        userName: `${localStorage.getItem('firstname') || ''} ${localStorage.getItem('lastname') || ''}`.trim() || 'Guest',
        functionAffected: 'Purchase Plan',
        description: 'Plan purchase failed from manage payment methods',
        severity: 'high',
        errorMessage: responseData || error?.message || 'Plan purchase failed',
        responseStatus: error?.response?.status || null,
        responseBody: responseData || null,
        requestUrl: `${baseUrl}/${endpoints.addPlanV2}`,
        requestMethod: 'POST',
        component: 'ManagePaymentMethods',
        userAction: 'Purchase plan called',
      });
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: responseData || 'Oops! Something went wrong while renewing plan',
      });
    } finally {
      setRenewingPlan(false);
    }
  };
  const handleAddNewCard = (card) => {
    setcardUpdateBoolean(false);
    setcardAdded(false);
    setOpen(true);
  };
  const handleUpdateCard = (card, id) => {
    setcardUpdateBoolean(true);
    setcardPayId({ card, id });
    setcardAdded(false);
    setOpen(true);
  };

  return (
    <Page headerTheme={styles.headerTheme}>
      {
        didCardAdded === true && isInActiveUser && (
          <InfoModal
            isVisible={didCardAdded}
            title="Your subscription needs to be renewed"
            content={(
              <pre>
                Projector subscription was paused as your renewal with your
                {'\n'}
                payment method on file was unsuccessful.
                {'\n'}
                Do you wish to renew now?
              </pre>
            )}
            onHide={() => handleUpdateState()}
            continueButton="Not now"
            action={() => renewPlan()}
            actionButton="Renew"
            isDelete
            fromPayment="true"
          />
        )
      }
      <div className={styles.main_page}>
        <div className={styles.headings}>

          <div className={styles.primary_heading}>
            {paymentMethodText?.title || 'Manage payment info'}
          </div>
          <div
            className={styles.secondary_heading}
          >
            {paymentMethodText?.description || 'Edit your payment details, add a backup or switch your preferred payment method.'}

          </div>
        </div>
        <div className={styles.main_container}>

          <div className={styles.cardContainer}>

            {paymentMethods?.map(({ card, id, last_attempt }) => (
              <CardDetails
                paymentMethods={paymentMethods}
                expMonth={card?.exp_month}
                expyear={card?.exp_year}
                brand={card.brand}
                last4={card.last4}
                cardId={id}
                card={card}
                handleUpdateCard={handleUpdateCard}
                status={last_attempt}
                removedAllowed={subscriptionDetails?.paymentMethods?.length > 1}
                isPreferred={subscriptionDetails?.default_payment_methods === id}
              />
            ))}
            {subscriptionDetails?.paymentMethods?.length <= 1 && (
              <div className={styles.message}>
                {paymentMethodText?.removeValidation || 'To delete payment method, add a new one'}
              </div>
            )}
          </div>

          <div
            className={styles.button_container}
          >
            <button onClick={handleAddNewCard}>
              {paymentMethodText?.addMethod || 'Add new payment method'}
            </button>
          </div>
        </div>

      </div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <AddCard closeAddCard={handleClose} />

      </Dialog>
    </Page>
  );
}
